<template>
    <v-flex xs12 mb-4 pt-4 id="events">
        <v-toolbar text>
            <v-toolbar-title>События и акции</v-toolbar-title>
            <v-spacer/>
            <v-btn icon text>
                <v-switch v-model="news.status"/>
            </v-btn>
        </v-toolbar>
        <v-layout flex wrap v-show="news.status">
            <v-flex xs12>
                <v-subheader class="pa-0">Краткое описание</v-subheader>
                <v-textarea
                    ref="news_description"
                    v-model="news.text"
                    text
                    solo
                    single-line/>
            </v-flex>
            <v-flex xs4 v-for="(item, index) in news.items" :key="index" class="pa-2">
                <v-layout xs12 flex wrap row>
                    <v-flex xs2>
                        <v-checkbox v-model="item.in_main" color="#000" class="mt-0 pt-0"/>
                    </v-flex>
                    <v-flex xs10>
                        <v-card>
                            <v-img class="white--text" height="200px" :src="rootURL + item.img">
                                <v-container fill-height fluid class="news-container">
                                    <v-layout fill-height>
                                        <v-flex xs12 align-end flexbox class="news-name">
                                            <span class="headline">{{ item.name }}</span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import config from '../../config'

    export default {
        name: 'newsSite',
        props: ['news'],
        data: () => ({
            rootURL: '',
        }),
        mounted () {
            this.rootURL = config.rootPath
        }
    }
</script>

<style lang="scss">.news {
    &-container {
        background-color: rgba(#000, 0.5);
    }

    &-name {
        display: flex;

        .headline {
            font: 400 14px 'Roboto' !important;
        }
    }
}
</style>
